import escapeHTMLTags from '@sdk/utils/escapeHTMLTags';

const ELEMENT_NODE_TYPE = 1;
const TEXT_NODE_TYPE = 3;

export function highlightSearchResult(content: string, search: string): string {
  const dummySpan = document.createElement('span');
  dummySpan.innerHTML = content;
  const uppercaseSearchWords = search.toUpperCase().split(' ');

  function _replaceInElement(element: HTMLSpanElement | ChildNode) {
    const childNodes = Array.from(element.childNodes);

    childNodes.forEach((node) => {
      if (node.nodeType === TEXT_NODE_TYPE) {
        const uppercaseTextContent = node.textContent.toUpperCase();
        let wrapped = escapeHTMLTags(node.textContent);
        uppercaseSearchWords.forEach((keyword) => {
          if (keyword && uppercaseTextContent.includes(keyword)) {
            const searchRegExp = new RegExp(
              keyword.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'),
              'gi'
            );

            wrapped = wrapped.replace(
              searchRegExp,
              (match) => `<span class="search-match">${escapeHTMLTags(match)}</span>`
            );
          }
        });

        const span = document.createElement('span');
        span.innerHTML = wrapped;
        element.replaceChild(span, node);
      } else if (node.nodeType === ELEMENT_NODE_TYPE) {
        _replaceInElement(node);
      }
    });
  }

  _replaceInElement(dummySpan);
  return dummySpan.innerHTML;
}
